import { Component, OnDestroy, OnInit } from '@angular/core';
import { ColmecWorkingOrderListConfigService } from '../../../services/colmec-working-order-list-config.service';
import { AuthService, CustomerService, SelectedCustomerService } from 'gung-standard';
import { Subject, combineLatest, filter, first, forkJoin, of, switchMap, takeUntil } from 'rxjs';
import { ColmecPartnerAgreementsService } from '../../../services/colmec-partner-agreements.service';

@Component({
    selector: 'colmec-working-order-list',
    templateUrl: './colmec-working-order-list.component.html',
    styleUrls: ['./colmec-working-order-list.component.scss'],
    standalone: false
})
export class ColmecWorkingOrderListComponent implements OnInit, OnDestroy {
  public isLoading: boolean = true;
  protected unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public configService: ColmecWorkingOrderListConfigService,
    protected authService: AuthService,
    protected selectedCustomerService: SelectedCustomerService,
    protected customerService: CustomerService,
    protected colmecPartnerAgreementsService: ColmecPartnerAgreementsService
  ) { }

  ngOnInit(): void {
    combineLatest({
      isAdmin: this.authService.getHasRoles('ADMIN').pipe(first()),
      isSales: this.authService.getHasRoles('SALES').pipe(first()),
      partnerId: this.selectedCustomerService.getSelectedCustomer().pipe(
        first(),
        switchMap(selectedCustomer => of(selectedCustomer.id))
      ),
      customers: this.customerService.getCustomers().pipe(first()),
      agreements: this.colmecPartnerAgreementsService.getPartnerAgreements().pipe(
        takeUntil(this.unsubscribe),
        filter(agreements => agreements.length > 0)
      )
    }).subscribe(({ isAdmin, isSales, partnerId, customers, agreements }) => {
      this.configService.isAdmin = isAdmin;
      this.configService.isSales = isSales;
      this.configService.partnerId = partnerId;
      this.configService.customers = customers;
      this.configService.agreements = agreements;
      this.isLoading = false;
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
